var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyseIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 41,
    height: 27.8708,
    rx: 5,
    stroke: "#5062F0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4386 7.54785C17.1011 7.54785 13.5848 11.0212 13.5848 15.3059C13.5848 19.5905 17.1011 23.0639 21.4386 23.0639C23.2247 23.0639 24.8716 22.4749 26.191 21.4829L28.7543 24.0149C29.1687 24.4243 29.8407 24.4243 30.2552 24.0149C30.6697 23.6055 30.6697 22.9417 30.2552 22.5323L27.6919 20.0003C28.6962 18.6969 29.2924 17.0702 29.2924 15.3059C29.2924 11.0212 25.7761 7.54785 21.4386 7.54785ZM15.7075 15.3059C15.7075 12.1793 18.2734 9.64462 21.4386 9.64462C24.6038 9.64462 27.1697 12.1793 27.1697 15.3059C27.1697 18.4325 24.6038 20.9671 21.4386 20.9671C18.2734 20.9671 15.7075 18.4325 15.7075 15.3059Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1887 38.3223C10.1887 37.77 10.6364 37.3223 11.1887 37.3223H32.9623C33.5146 37.3223 33.9623 37.77 33.9623 38.3223V38.9997H10.1887V38.3223Z",
    fill: "#5062F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6147 33.8383C17.7427 33.417 18.1312 33.1289 18.5716 33.1289H25.5793C26.0197 33.1289 26.4082 33.417 26.5362 33.8383L27.5943 37.3224H16.5566L17.6147 33.8383Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyseIconBlue);
export default __webpack_public_path__ + "static/media/analyseIconBlue.1de7555b5dc7cdb8e4a476726d95ee81.svg";
export { ForwardRef as ReactComponent };